// The OAuth2 `state` carries the target environment as `{env}:{organizationId}`
// so the SSO callback can be routed to the right deployment. Redirect targets
// come only from this allowlist, never from raw `state`.
export const SSO_ENV_HOSTS: Record<string, string> = {
  dev: "dev.login.allobrain.com",
  prod: "login.allobrain.com",
  next: "next.login.allobrain.com",
  "next-dev": "next-dev.login.allobrain.com",
};

export interface ParsedState {
  targetEnv: string | null;
  organizationId: string;
}

export function parseState(state: string): ParsedState {
  const separatorIndex = state.indexOf(":");
  if (separatorIndex === -1) {
    return { targetEnv: null, organizationId: state };
  }

  const prefix = state.slice(0, separatorIndex);
  if (Object.prototype.hasOwnProperty.call(SSO_ENV_HOSTS, prefix)) {
    return { targetEnv: prefix, organizationId: state.slice(separatorIndex + 1) };
  }

  // Unknown prefix: keep the whole value as the org id and handle it locally.
  return { targetEnv: null, organizationId: state };
}

// Returns the URL to route the callback to, or null to handle it locally.
export function resolveSsoRedirect(
  state: string,
  currentHost: string,
  search: string,
): string | null {
  const { targetEnv } = parseState(state);
  if (!targetEnv) {
    return null;
  }

  const targetHost = SSO_ENV_HOSTS[targetEnv];
  if (!targetHost || targetHost === currentHost) {
    return null;
  }

  return `https://${targetHost}/sso${search}`;
}
